export default __webpack_public_path__ + "static/media/Route_line.1016c2d3.svg";